import React from 'react';
import {func} from 'prop-types';
import {Icon} from 'semantic-ui-react';

// Same accept list Filestack is configured with, see observables/lettables/pickFile.js:10
export const ACCEPTED_IMAGE_TYPES = ["image/jpg", "image/jpeg", "image/png", "image/gif", "image/svg+xml"];

/*
    "My Device" tab: a file input plus a drag-and-drop zone. Reports a single
    valid File up to the parent via onFileSelected, or a message via onError
    when the dropped/selected file's type isn't in ACCEPTED_IMAGE_TYPES.

    One file at a time, matching Filestack's current maxFiles: 1 configuration.
*/
export default class ImageUploadDeviceTab extends React.Component {
  state = {
    isDragActive: false
  };

  fileInputRef = React.createRef();

  handleBrowseClick = () => {
    if (this.fileInputRef.current) {
      this.fileInputRef.current.click();
    }
  };

  handleInputChange = (event) => {
    this.processFiles(event.target.files);
    // reset so selecting the same file again still fires onChange
    event.target.value = '';
  };

  handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.setState({isDragActive: true});
  };

  handleDragLeave = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.setState({isDragActive: false});
  };

  handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.setState({isDragActive: false});
    this.processFiles(event.dataTransfer ? event.dataTransfer.files : null);
  };

  processFiles = (fileList) => {
    if (!fileList || fileList.length === 0) {
      return;
    }

    const file = fileList[0];
    if (ACCEPTED_IMAGE_TYPES.indexOf(file.type) === -1) {
      this.props.onError(
        `Unsupported file type "${file.type || 'unknown'}". Accepted types: ${ACCEPTED_IMAGE_TYPES.join(', ')}.`
      );
      return;
    }

    this.props.onFileSelected(file);
  };

  render() {
    const {isDragActive} = this.state;
    const dropzoneClassName = "db-image-upload-dropzone" +
      (isDragActive ? " db-image-upload-dropzone--active" : "");

    // Inline, not stylesheet-based -- there's no dedicated CSS file for this
    // component tree to hook the `--active` class into (everything else here
    // is either vendor CSS or per-component inline styles).
    const dropzoneStyle = {
      border: '2px dashed ' + (isDragActive ? '#2185d0' : '#ccc'),
      borderRadius: 4,
      padding: '40px 20px',
      textAlign: 'center',
      cursor: 'pointer',
      backgroundColor: isDragActive ? '#eaf4fd' : 'transparent',
      transition: 'background-color 0.15s ease, border-color 0.15s ease'
    };

    return (
      <div
        className={dropzoneClassName}
        style={dropzoneStyle}
        onDragOver={this.handleDragOver}
        onDragEnter={this.handleDragOver}
        onDragLeave={this.handleDragLeave}
        onDrop={this.handleDrop}
        onClick={this.handleBrowseClick}>
        {/* pointerEvents: none keeps drag/click targeting on the outer div --
            otherwise crossing from the div's padding onto these children
            fires spurious dragleave/dragenter pairs and the active state flickers. */}
        <div style={{pointerEvents: 'none'}}>
          <Icon name="upload" size="huge" color={isDragActive ? 'blue' : undefined} />
          <p>{isDragActive ? 'Drop the image to upload it.' : 'Drag and drop an image here, or click to browse.'}</p>
        </div>
        <input
          ref={this.fileInputRef}
          type="file"
          accept={ACCEPTED_IMAGE_TYPES.join(',')}
          style={{display: 'none'}}
          onChange={this.handleInputChange} />
      </div>
    );
  }
}

ImageUploadDeviceTab.propTypes = {
  onFileSelected: func.isRequired,
  onError: func.isRequired
};



// WEBPACK FOOTER //
// ./public/components/images/ImageUploadDeviceTab.jsx